import { render, staticRenderFns } from "./AIAssessment_v2.vue?vue&type=template&id=2d93bfac&scoped=true&"
import script from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
export * from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIAssessment_v2.vue?vue&type=style&index=0&id=2d93bfac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93bfac",
  null
  
)

export default component.exports